import { ArrowRight } from "lucide-react";

export function GuidePrice({ brk, large = false }) {
  if (brk.guide_price == null) {
    return (
      <a
        href={brk.spe_deep_link}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition-colors duration-300 hover:text-accent"
        data-testid="guide-price-fallback"
      >
        See current price <ArrowRight className="h-4 w-4" />
      </a>
    );
  }
  return (
    <div data-testid="guide-price">
      <p className={large ? "price-pop !text-4xl sm:!text-5xl" : "price-pop"}>
        From £{brk.guide_price} <span className="text-base font-sans font-semibold text-ink sm:text-lg">{brk.price_basis}</span>
      </p>
      {large && (
        <p className="mt-1 text-xs text-ink-muted" data-testid="guide-price-note">
          Guide price — final live pricing for your dates is shown when you book.
        </p>
      )}
    </div>
  );
}
